import { useContext } from 'react';
import { AuthContext } from './authContext/context';

// Diagnostic component to check auth state
export default function TestAuthState() {
  const authCtx = useContext(AuthContext);

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>🔍 Auth State Diagnostic</h1>
      <hr />

      <h2>Token Status:</h2>
      <p><strong>Has Token:</strong> {authCtx.token ? '✅ YES' : '❌ NO'}</p>
      <p><strong>Token Value:</strong> {authCtx.token ? `${authCtx.token.substring(0, 20)}...` : 'null'}</p>

      <hr />

      <h2>User Info:</h2>
      <p><strong>Username:</strong> {authCtx.user?.username || 'null'}</p>
      <p><strong>Email:</strong> {authCtx.user?.email || 'null'}</p>
      <p><strong>User ID:</strong> {authCtx.user?.userId || 'null'}</p>

      <hr />

      <h2>Role Info:</h2>
      <p><strong>Role:</strong> {authCtx.role || 'null'}</p>
      <p><strong>Status:</strong> {authCtx.status || 'null'}</p>
      <p><strong>Is SuperAdmin:</strong> {authCtx.isSuperAdmin ? '✅ YES' : '❌ NO'}</p>

      <hr />

      <h2>Full Context:</h2>
      <pre style={{ background: '#f4f4f4', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
        {JSON.stringify(authCtx, null, 2)}
      </pre>

      <hr />

      <div style={{ marginTop: '20px' }}>
        <h3>Next Steps:</h3>
        {!authCtx.token ? (
          <>
            <p style={{ color: 'red' }}>⚠️ No token found! You need to log in first.</p>
            <a href="/login" style={{ padding: '10px 20px', background: '#007bff', color: 'white', textDecoration: 'none', borderRadius: '4px', display: 'inline-block' }}>
              Go to Login
            </a>
          </>
        ) : (
          <>
            <p style={{ color: 'green' }}>✅ Token exists! Protected routes should work.</p>
            <a href="/role-dashboard" style={{ padding: '10px 20px', background: '#28a745', color: 'white', textDecoration: 'none', borderRadius: '4px', display: 'inline-block', marginRight: '10px' }}>
              Try Protected Role Dashboard
            </a>
            <a href="/role-dashboard-unprotected" style={{ padding: '10px 20px', background: '#ffc107', color: 'black', textDecoration: 'none', borderRadius: '4px', display: 'inline-block' }}>
              Try Unprotected Role Dashboard
            </a>
          </>
        )}
      </div>
    </div>
  );
}
